export function clientNcnsEncounterLabel(amount: number): string {
  return Number(amount) === 25 ? 'Client No-Show — $25' : 'Client No-Show — $0';
}
